import { render, staticRenderFns } from "./details-modules.vue?vue&type=template&id=309a50a8"
import script from "./details-modules.vue?vue&type=script&lang=js"
export * from "./details-modules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports